import React from 'react';
import DentalServicePage from './DentalServicePage';

const GumDiseaseTreatment = () => {
    // Defined content for Gum Disease Treatment
    const serviceName = 'Gum Disease Treatment';
    const serviceTagline = 'Specialized care to restore and maintain your gum health and protect your smile';

    const whatIsContent = [
        'Gum disease (periodontal disease) is a common inflammatory condition affecting the soft tissues surrounding the teeth and, if left untreated, the supporting bone structures as well. It begins with bacterial growth in your mouth and can progress to tooth loss if not properly treated. At Wisdom Dental Clinic, we offer comprehensive gum disease treatment at all stages, from early gingivitis to advanced periodontitis.',
        'Our approach to periodontal care combines thorough cleaning techniques, advanced technology, and evidence-based treatments to address the root causes of gum disease, eliminate infection, and create an environment where your gums can heal. We focus not only on treating current symptoms but also on preventive strategies to maintain your gum health for the long term.',
    ];

    const whenRequiredContent = {
        paragraphs: [
            'Gum disease often develops silently, which makes regular dental checkups crucial for early detection and intervention.',
        ],
        listIntro: 'You may need gum disease treatment if you notice:',
        list: [
            'Red, swollen, or tender gums',
            'Bleeding while brushing or flossing',
            'Receding gums (teeth appearing longer)',
            'Persistent bad breath or bad taste',
            'Loose or shifting teeth',
            'Changes in the way your teeth fit together',
            'Pus between teeth and gums',
            'Formation of deep pockets between teeth and gums',
        ],
        closing:
            "Early intervention is key to successful treatment. If you're experiencing any of these symptoms, we recommend scheduling an evaluation promptly to prevent progression of the disease and potential tooth loss.",
    };

    const howDoneContent = {
        paragraphs: [
            'At Wisdom Dental Clinic, our periodontal care integrates traditional techniques with advanced technology for optimal outcomes in gum disease treatment.',
        ],
        listIntro: 'Our gum disease treatment options include:',
        list: [
            'Comprehensive periodontal evaluation and digital mapping',
            'Scaling and root planing (deep cleaning) with ultrasonic instruments',
            'Laser-assisted periodontal therapy for minimal discomfort',
            'Localized antibiotic therapy to target persistent infections',
            'Surgical interventions including gum grafting when necessary',
            "Host modulation therapy to enhance your body's healing response",
            'Personalized periodontal maintenance programs',
        ],
        closing:
            'Our specialists have extensive experience in periodontal treatments and stay current with the latest research and techniques. We tailor our approach to your specific condition, health history, and personal needs to deliver the most effective care with minimal discomfort.',
    };

    const benefitsContent = [
        {
            title: 'Halts Disease Progression',
            description: 'Stops the advancement of gum disease and prevents further damage',
        },
        {
            title: 'Preserves Natural Teeth',
            description: 'Helps maintain your natural teeth by strengthening supporting structures',
        },
        {
            title: 'Reduces Inflammation',
            description: 'Decreases gum inflammation and associated discomfort',
        },
        {
            title: 'Eliminates Bad Breath',
            description: 'Removes bacteria causing persistent bad breath',
        },
        {
            title: 'Improves Overall Health',
            description: 'Reduces risk of systemic conditions linked to periodontal disease',
        },
        {
            title: 'Enhances Smile Aesthetics',
            description: 'Restores healthy, pink gum tissue for a more attractive smile',
        },
    ];

    const procedureSteps = [
        {
            title: 'Comprehensive Assessment',
            description:
                'Detailed evaluation including periodontal probing, digital imaging, and assessment of risk factors to determine the extent and severity of your gum disease',
        },
        {
            title: 'Customized Treatment Planning',
            description: 'Development of a personalized treatment approach based on your specific condition, health history, and goals',
        },
        {
            title: 'Initial Therapy',
            description:
                'Thorough scaling and root planing (deep cleaning) to remove plaque, tartar, and bacteria from below the gumline and smooth root surfaces',
        },
        {
            title: 'Adjunctive Treatments',
            description:
                'Application of targeted therapies such as localized antibiotics, antimicrobial rinses, or laser treatment to enhance healing and infection control',
        },
        {
            title: 'Advanced Procedures',
            description:
                'For more severe cases, surgical interventions may be recommended, such as pocket reduction, regenerative procedures, or gum grafting',
        },
        {
            title: 'Periodontal Maintenance',
            description:
                'Implementation of a structured maintenance program with more frequent cleanings and monitoring to prevent recurrence and maintain gum health',
        },
    ];

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
        />
    );
};

export default GumDiseaseTreatment;
